const CategoriesAT = {
  CMS_FETCH_CATEGORIES_REQUEST: 'CMS_FETCH_CATEGORIES_REQUEST',
  CMS_FETCH_CATEGORIES_SUCCESS: 'CMS_FETCH_CATEGORIES_SUCCESS',
  CMS_FETCH_CATEGORIES_FAILURE: 'CMS_FETCH_CATEGORIES_FAILURE',
} as const;

export default { ...CategoriesAT };
